module.exports = __webpack_public_path__ + "static/media/luke.945aa2a0.jpg";